import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import IGetActiveTarhHayeSodoorByNoeBimehQuery from 'Feature/Common/Common/Types/Queries/IGetActiveTarhHayeSodoorByNoeBimehQuery';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getAllTarhHayeSodoorByNoeBimeh = createAsyncThunk(
  'TarhSodoor/GetActiveTarhHayeSodoorByNoeBimeh',
  async (query: IGetActiveTarhHayeSodoorByNoeBimehQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.TarhSodoor.GetActiveTarhHayeSodoorByNoeBimeh}`,
      params: query,
    });
  }
);
